module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(!_vm.hasEntered) ? _c('div', {
    staticClass: "overlay",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-overlay')
    }),
    on: {
      "~click": function($event) {
        $event.preventDefault();
        _vm.openSesame($event)
      }
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._t("default")], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70d9a618","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overlay.vue
// module id = 465
// module chunks = 1